import { ISettings } from '@/interfaces/settings.interfaces';

const getFiltersInitialSettings = ({ filters }: ISettings) => filters.initialValues || {};

export default getFiltersInitialSettings;
